import { Sheet } from '@/components/ui'
import React from 'react'
import { Sheet as TamaguiSheet } from 'tamagui'


interface LessonSheetProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  children: React.ReactNode
}

export function LessonSheet({ open, onOpenChange, children }: LessonSheetProps) {
  return (
    <Sheet
      open={open}
      onOpenChange={onOpenChange}
    >
       <TamaguiSheet.ScrollView
          nestedScrollEnabled={false}
          keyboardDismissMode="on-drag"
          scrollEventThrottle={16}
          showsVerticalScrollIndicator={false}
          bounces={false}
          alwaysBounceVertical={false}
          disableScrollViewPanResponder={true}
          contentInsetAdjustmentBehavior="never"
          contentContainerStyle={{ paddingBottom: 24 }}
        >
        {children}
        </TamaguiSheet.ScrollView>
    </Sheet>
  )
}